import { OperatorFunction, pipe } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { CommitmentService } from '../../../coaching-commitment/services/commitment.service';
import { Dependencies } from '../../../store';
import { FocusSelectorService } from '../../services/focus-selector.service';
import { InitEpicChainGroup } from '../model/focus-selector-init-epic-chain-group.model';

export function retrieveGoalThresholds(
    deps: Dependencies,
    grp: InitEpicChainGroup,
): OperatorFunction<any, InitEpicChainGroup> {
    const cService = deps.injector.get<CommitmentService>(CommitmentService);

    return pipe(
        cService.retrieveCommitmentConfig(),
        tap((ret) => {
            grp.goalThresholds = ret?.goalThresholds ?? [];
        }),
        mapTo(grp),
    );
}

export function retrieveFocusesForPerformer(
    deps: Dependencies,
    grp: InitEpicChainGroup,
): OperatorFunction<any, InitEpicChainGroup> {
    const fService =
        deps.injector.get<FocusSelectorService>(FocusSelectorService);

    return pipe(
        fService.retrieveFocusesForPerformer(() => ({
            userId: grp.root.performerId,
        })),
        tap((ret) => {
            grp.active = ret?.active ?? [];
            grp.closed = ret?.closed ?? [];
            grp.teamActive = ret?.teamActive ?? [];
            grp.teamClosed = ret?.teamClosed ?? [];
            grp.coachableMetrics = ret?.coachableMetrics ?? [];
            grp.populationFocuses = ret?.populationFocuses ?? [];
            grp.other = ret?.other ?? [];
        }),
        mapTo(grp),
    );
}
